// extracted by mini-css-extract-plugin
export default {"copy_button":"styles_copy_button__w3FRd"};